module.exports = __webpack_public_path__ + "static/img/g9.a1e29a48.png";